__turbopack_context__.v({
  "makersReserve": "Default-module-scss-module__hMwFZq__makersReserve",
});
